module.exports = __webpack_public_path__ + "images/a67954a55b0434560d0219847823fbfc.png";